<template>
<div 
    class="empty-row"
    :style="{
        height: computedHeight,
        ...style,
    }"
>
</div>
</template>
<script>
export default {
    name: 'EmptyRow',
    props: {
        height: {
            type: [String, Number],
            default: '40'
        },
        style: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        computedHeight () {
            if(typeof this.height === 'string' && !isNaN(this.height)) {
                return `${this.height}px`;
            }
            return '40px';
        }
    },
};
</script>
<style lang="scss" scoped>
.empty-row {
    width: 100%;
}
</style>
